export const TILE_URLS = {
  Production: 'https://tiles.tilda-geo.de',
  ProdNoCache: 'https://cacheless.tilda-geo.de',
  Staging: 'https://staging-tiles.tilda-geo.de',
  StgNoCache: 'https://staging-cacheless.tilda-geo.de',
  Development: 'http://127.0.0.1:3000',
} as const

export type TileSourceKey = 'Production' | 'Staging' | 'Development'

export type CacheMode = 'cached' | 'nocache'

export const TILE_SOURCE_KEYS: TileSourceKey[] = ['Production', 'Staging', 'Development']

const CACHE_MODES = ['cached', 'nocache'] as const

export function getTileBaseUrl(source: TileSourceKey, cacheMode: CacheMode) {
  if (source === 'Development') return TILE_URLS.Development
  if (source === 'Production')
    return cacheMode === 'cached' ? TILE_URLS.Production : TILE_URLS.ProdNoCache
  return cacheMode === 'cached' ? TILE_URLS.Staging : TILE_URLS.StgNoCache
}

export const CACHE_MODE_VALUES: readonly CacheMode[] = CACHE_MODES

export const baseMapStyle =
  'https://api.maptiler.com/maps/08357855-50d4-44e1-ac9f-ea099d9de4a5/style.json?key=ECOoUBmpqklzSCASXxcu'
